import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_link",
  "use": "micro_link-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_link\"><g fill-rule=\"evenodd\"><path d=\"M3 7c-1.108 0-2-.89-2-2 0-1.102.902-2 2.01-2h.98C5.101 3 6 3.895 6 5v.966h1V5c0-1.658-1.348-3-3.01-3h-.98A3.008 3.008 0 0 0 0 5c0 1.663 1.34 3 3 3V7Z\" /><path d=\"M7 3c1.108 0 2 .89 2 2 0 1.102-.902 2-2.01 2h-.98A2.004 2.004 0 0 1 4 5V3.95H3V5c0 1.658 1.348 3 3.01 3h.98A3.008 3.008 0 0 0 10 5c0-1.663-1.34-3-3-3v1Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol